export const COLLAPSED_SIDE_PANEL_WIDTH_PX = 36;
